<div class="headerdiv">
  <h1>Offer Management</h1>
</div>
<div class="card-body">
  <div class="col-md-12">
    <div class="mt-2">
      <div class="row">
        <div class="col-md-3 column_width align-items-center">
          <div class="form-group ">
            <label>Offer Id</label>
            <input type="text" [(ngModel)]="offers.OFFER_ID" class="form-control" />
          </div>
        </div>
        <div class="col-md-3 mt-2 column_width align-items-center">
          <mat-form-field>
            <input id="did" #input1 matInput [matDatepicker]="pickerFrom" (dateChange)="incresedate(); isEmpty()"
              autocomplete="off" placeholder="Startdate" readonly [min]="myDate" [(ngModel)]="offers.START_DATE" />
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </mat-form-field>

          <button type="button" class="close opa" (click)="resetFrom(); checkStatusFrom()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <br />
        </div>
        <div class="col-md-3 mt-2 column_width align-items-center">
          <mat-form-field>
            <input [min]="final" #input2 matInput [disabled]="isEndDate" [matDatepicker]="pickerTo"
              (dateChange)="isEmpty()" autocomplete="off" placeholder="Enddate" readonly
              [(ngModel)]="offers.END_DATE" />
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </mat-form-field>
          <button type="button" class="close opa" (click)="resetTo()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <br />
          <span *ngIf="invaliddate" style="color: red;font-size: 10px">
            'To' date should be greater than 'From' date
          </span>
        </div>
        <div class="col-md-2 column_width align-items-center">
          <label>Rzypay MID</label>
          <select [(ngModel)]="offers.RZY_PAY_MID" class="form-control m-input text-uppercase"
            (ngModelChange)="travel_type_changes($event)">

            <option [value]="default_rzypay_mid.ID" disabled>
              {{default_rzypay_mid.MID_NAME}}
            </option>
            <option *ngFor="let data of rzypay_mid_list" [value]="data.ID">
              {{data.MID_NAME}}
            </option>

          </select>
        </div>

      </div>
      <div class="row">
        <div class="col-md-2 column_width align-items-center">
          <label>TRAVEL_TYPE</label>
          <select [(ngModel)]="offers.TRAVEL_TYPE" class="form-control m-input text-uppercase">
            <option [value]="default_rzypay_mid.ID" disabled>
              {{default_rzypay_mid.MID_NAME}}
            </option>

            <option *ngFor="let data of travel_type_list" [value]="data.ID" [disabled]="iscobrands==true">
              {{data.TRAVEL_NAME}}
            </option>
          </select>
        </div>
        <div class="col-md-2 column_width align-items-center">
          <label>Status</label>
          <select [(ngModel)]="offers.STATUS" class="form-control m-input text-uppercase">
            <option [value]="default_rzypay_mid.ID" disabled>
              {{default_rzypay_mid.MID_NAME}}
            </option>
            <option value="active">ACTIVE</option>
            <option value="inactive">INACTIVE</option>
          </select>
        </div>
      </div>
      <div class="mt-1">
        <button [innerHTML]="isEdit == true ? 'Edit Offer' : 'Add Offer'" type="button" (click)="createOffers()"
          class="btn btn-info btn-sm btn-right"></button>
      </div>
    </div>

    <!-- Offer - List Table -->
    <div style="margin-top: 6rem;" *ngIf="listOffers != '' || listOffers != 0">
      <table aria-describedby="offerDetails" class="table table-striped mt-2" *ngIf="!loader" [mfData]="serachtabledata"
        [mfRowsOnPage]="5">
        <thead>
          <tr>
            <th scope="col" class="text-center">OFFER ID</th>
            <th scope="col" class="text-center">START DATE</th>
            <th scope="col" class="text-center">END DATE</th>
            <th scope="col" class="text-center">RZY_PAY_MID</th>
            <th scope="col" class="text-center">TRAVEL_TYPE</th>
            <th scope="col" class="text-center">STATUS</th>
            <th scope="col" class="text-center">Action</th>

          </tr>
        </thead>
        <tbody>
          <tr class="link" *ngFor="
              let offers of listOffers
                | paginate
                  : {
                      itemsPerPage: 10,
                      currentPage: p,
                      totalItems: totalItems
                    };
              let id = index
            ">
            <td class="text-center">
              {{ offers.OFFER_ID }}
            </td>
            <td class="text-center">
              {{ offers.START_DATE | date: "MM/d/y" }}
            </td>
            <td class="text-center">{{ offers.END_DATE | date: "MM/d/y" }}</td>
            <td class="text-center text-uppercase">{{ offers.RZY_PAY_MID }}</td>
            <td class="text-center text-uppercase">{{ offers.TRAVEL_TYPE }}</td>
            <td class="text-center text-uppercase">{{ offers.STATUS }}</td>
            <td class="text-center">
              <span (click)="editOffer(offers)" class="glyphicon glyphicon-edit" style="margin-right: 1rem;"></span>
              <span (click)="deleteOffer(offers)" class="glyphicon glyphicon-trash"></span>
            </td>

          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="15">
              <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
              </pagination-controls>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div style="margin-top: 6rem;" *ngIf="listOffers == '' || listOffers == 0">
      <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
        {{ noresult }}
      </h1>
    </div>
  </div>
</div>